module.exports = __webpack_public_path__ + "img/send-individual.6f5934bb.svg";